module.exports = __webpack_public_path__ + "img/expovina_09.4ea61db2.jpg";